module.exports = __webpack_public_path__ + "static/NERF_Light_it_Up-9ba6f503bef70e75433ab3d730cb3b64.jpg";